import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_INTEGRATION_DRONE_SHOTS',
  name: 'Workspace Project Drone Shot Integration',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: '_userId', title: 'User' },
    { key: '_fileId', title: 'File' },
    { key: '_geoDataFileId', title: 'Geo Data file' },
    { key: 'status', title: 'Status' },
    { key: 'name', title: 'Name' },
    { key: 'pinned', title: 'Pinned' },
    { key: 'featured', title: 'Featured' },
    { key: 'type', title: 'Type' },
    { key: 'caption', title: 'Caption' },
    { key: 'capturedAt', title: 'Captured date' },
  ],
  actions: ['READ', 'CREATE', 'UPDATE', 'UPLOAD', 'DESTROY'],
}

export default scope
